/* eslint-disable no-useless-constructor */
/* eslint-disable no-alert */

import feathersClient, { BaseModel, makeServicePlugin } from "../feathers-client";

class Deltas extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Deltas";
}

const servicePlugin = makeServicePlugin({
  Model: Deltas,
  service: feathersClient.service("deltas"),
});

export default servicePlugin;
